import { useState } from 'react'
import ErrorAlert from './ErrorAlert'
import { t } from '../utils/i18n'
import { BACKEND_URL } from '../utils/settings'

const FileUploader = (props) => {
  const [error, setError] = useState(null)
  const [uploading, setUploading] = useState(false)
  let input

  const onFileSelected = () => {
    let file = input.files[0]
    if (!file) {
      return
    }
    setUploading(true)

    let url
    createUpload(file)
      .then((resp) => {
        url = resp.url
        return upload(resp.upload_url, file)
      })
      .then(() => {
        props.uploaded(url)
      })
      .catch((e) => {
        console.error(e)
        setUploading(false)
        setError(e.message)
      })
  }

  const createUpload = (file) => {
    return new Promise((resolve, reject) => {
      let xhr = new XMLHttpRequest()
      xhr.open('POST', BACKEND_URL + '/api/uploads')
      xhr.setRequestHeader('content-type', 'application/json')
      xhr.responseType = 'json'
      xhr.onload = function () {
        if (xhr.status >= 200 && xhr.status < 300) {
          resolve(xhr.response)
        } else {
          reject(new Error('Upload failed.'))
        }
      }
      xhr.send(
        JSON.stringify({
          content_type: file.type,
          name: file.name,
          size: file.size
        })
      )
    })
  }

  const upload = (uploadUrl, file) => {
    return new Promise((resolve, reject) => {
      let xhr = new XMLHttpRequest()
      xhr.open('PUT', uploadUrl)
      xhr.onload = function () {
        if (xhr.status === 200) {
          resolve()
        } else {
          reject(new Error('Upload failed.'))
        }
      }
      xhr.send(file)
    })
  }

  if (uploading) {
    input = <div>{t('uploading_ellipsis')}</div>
  } else {
    input = (
      <input
        ref={(el) => (input = el)}
        type="file"
        className="velorbis-customizer-file-input"
        onChange={onFileSelected}
      />
    )
  }
  return (
    <div>
      <ErrorAlert error={error} />
      {input}
    </div>
  )
}

export default FileUploader
